var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"widget-item",style:(_vm.style),attrs:{"id":_vm.widget.object.wid}},[_c('TemplateViewer',{ref:"TemplateViewer",attrs:{"template":_vm.widget.object,"assocId":_vm.widget.assoc_id}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }